import React from 'react'
import { Col } from 'antd'
import HeaderComponent from './HeaderComponents'
import FooterPublic3D from './FooterPublic3D'
import { ExpertText, MediumHeaderTitle, SmallText } from './Text3D'

const WhyUse3Dmake = () => {
    return (
        <div>
            <HeaderComponent />
            <Col span={18} offset={3}>
                <div style={{ padding: '1rem' }}>
                    <MediumHeaderTitle dark style={{ fontSize: '2rem', textAlign: 'center' }}>Reasons to use 3Dprintit</MediumHeaderTitle>
                    <SmallText small bold style={{ paddingBottom: '1rem' }}>For 3D Printing Customers:</SmallText>
                    <SmallText small bold>Cheaper</SmallText>
                    <ExpertText dark style={{ fontSize: '1.2rem' }}>We are 5c per gram + $5 service fee + free pickup/$11.15 shipping compared to Jaycar $14.95 + 30c per gram</ExpertText>
                    <SmallText small bold>Ease of printing</SmallText>
                    <ExpertText dark style={{ fontSize: '1.2rem' }}>Simply upload, be quoted and print from the ease of your own home</ExpertText>
                    <SmallText small bold>Buyer protection</SmallText>
                    <ExpertText dark style={{ fontSize: '1.2rem' }}>Printer Satisfaction Guarantee or your money back!</ExpertText>
                    <SmallText small bold>Transparent Pricing</SmallText>
                    <ExpertText dark style={{ fontSize: '1.2rem' }}>We tell you the price per gram upfront unlike other websites like Shapeways which tell you a mysterious price</ExpertText>
                    <SmallText small bold style={{ paddingBottom: '1rem' }}> For 3D Printer Hubs:</SmallText>
                    <SmallText small bold>Monetize your idle 3D Printers</SmallText>
                    <ExpertText dark style={{ fontSize: '1.2rem' }}>Make money from your idle 3D Printers and turn it into a business</ExpertText>
                    <SmallText small bold>Pause taking jobs when you need to</SmallText>
                    <ExpertText dark style={{ fontSize: '1.2rem' }}>You can pause taking on new jobs when you need to</ExpertText>
                    <SmallText small bold>Instant quoting and specification section</SmallText>
                    <ExpertText dark style={{ fontSize: '1.2rem' }}>No more going back and forth for quotes and specifications</ExpertText>
                </div>
            </Col>
            <FooterPublic3D />
        </div>
    )
}

export default WhyUse3Dmake